export default __webpack_public_path__ + "static/media/icon_favorites.ecf68074.svg";